/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTrackingNumberByGoodsPlatformNoVo
 */
export interface UpdateTrackingNumberByGoodsPlatformNoVo {
    /**
     * 商品平台订单号
     * @type {string}
     * @memberof UpdateTrackingNumberByGoodsPlatformNoVo
     */
    purchasePlatformOrderNo?: string;
    /**
     * 中国快递运单号
     * @type {Array<string>}
     * @memberof UpdateTrackingNumberByGoodsPlatformNoVo
     */
    trackingNoList?: Array<string>;
}

/**
 * Check if a given object implements the UpdateTrackingNumberByGoodsPlatformNoVo interface.
 */
export function instanceOfUpdateTrackingNumberByGoodsPlatformNoVo(value: object): value is UpdateTrackingNumberByGoodsPlatformNoVo {
    return true;
}

export function UpdateTrackingNumberByGoodsPlatformNoVoFromJSON(json: any): UpdateTrackingNumberByGoodsPlatformNoVo {
    return UpdateTrackingNumberByGoodsPlatformNoVoFromJSONTyped(json, false);
}

export function UpdateTrackingNumberByGoodsPlatformNoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTrackingNumberByGoodsPlatformNoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'purchasePlatformOrderNo': json['purchasePlatformOrderNo'] == null ? undefined : json['purchasePlatformOrderNo'],
        'trackingNoList': json['trackingNoList'] == null ? undefined : json['trackingNoList'],
    };
}

export function UpdateTrackingNumberByGoodsPlatformNoVoToJSON(json: any): UpdateTrackingNumberByGoodsPlatformNoVo {
    return UpdateTrackingNumberByGoodsPlatformNoVoToJSONTyped(json, false);
}

export function UpdateTrackingNumberByGoodsPlatformNoVoToJSONTyped(value?: UpdateTrackingNumberByGoodsPlatformNoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'purchasePlatformOrderNo': value['purchasePlatformOrderNo'],
        'trackingNoList': value['trackingNoList'],
    };
}

